import { UseQueryResult, useQuery } from '@tanstack/react-query'

import { ClientLocationCamerasService } from '../services/client_location_cameras.service'
import { ClientLocationCamerasConfig, ClientLocationCamerasList } from '../types/cameras-api'
import { defaultQueryOptions } from './common'

export const useClientLocationCameras = (
  locationName: string,
  lupId: string,
  options: { refetchInterval?: number | false; refetchIntervalInBackground?: boolean } = {}
): UseQueryResult<ClientLocationCamerasList> => {
  const { refetchInterval, refetchIntervalInBackground } = options

  return useQuery<ClientLocationCamerasList>({
    queryKey: ['clientLocationCameras', locationName, lupId],
    queryFn: () => ClientLocationCamerasService.getCamerasList(locationName, lupId),
    enabled: !!lupId,
    ...defaultQueryOptions,
    refetchInterval,
    refetchIntervalInBackground,
  })
}

export const useClientLocationCamerasAccess = (
  locationName: string,
  lupId: string
): UseQueryResult<ClientLocationCamerasConfig> => {
  return useQuery<ClientLocationCamerasConfig>({
    queryKey: ['clientLocationCamerasAccess', locationName, lupId],
    queryFn: () => ClientLocationCamerasService.getCamerasAccess(locationName, lupId),
    enabled: !!lupId,
    ...defaultQueryOptions,
  })
}
